import {
  Box,
  Button,
  Card,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import TextFieldDebouncedNoInitialLoad from "../../../../../components/TextFieldDebouncedNoInitialLoad";
import {
  currencyFormatNoDecimals,
  toTwoDecimals,
} from "../../../../../components/NewDetail/calculations/utils";
import { useTheme } from "@emotion/react";
import AdornedInputDebouncedNoInitialLoad from "../../../../../components/AdornedInputDebouncedNoInitialLoad";

const Coil = ({ coil, onUpdateCoil }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box>
      <Typography sx={{ flex: 1 }} variant="h6">
        Coil
        {coil.totalSellPrice !== undefined && coil.totalSellPrice !== null
          ? ` - ${currencyFormatNoDecimals(
              Math.round(Number(coil.totalSellPrice ?? 0))
            )}`
          : ""}
      </Typography>
      <Box sx={{}}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isMediumScreen ? "column" : "row",
          }}
        >
          <Box sx={{}}>
            <Typography>Details</Typography>
            <Box
              sx={{ marginTop: "8px", display: "flex", flexDirection: "row" }}
            >
              <TextFieldDebouncedNoInitialLoad
                sx={{
                  width: "150px",
                }}
                onFocus={(e) => e.target.select()}
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                size="small"
                label="Lineal Feet"
                value={coil.linealFeet ? parseFloat(coil.linealFeet) : null}
                onChange={(e) => {
                  onUpdateCoil({
                    ...coil,
                    linealFeet: e.target.value,
                  });
                }}
              />
              <TextFieldDebouncedNoInitialLoad
                sx={{
                  width: "150px",
                  marginLeft: "8px",
                }}
                onFocus={(e) => e.target.select()}
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                variant="outlined"
                label="Width (in.)"
                id="width"
                name="Width (in.)"
                size="small"
                value={coil.width ? parseFloat(coil.width) : null}
                onChange={(e) => {
                  onUpdateCoil({
                    ...coil,
                    width: e.target.value,
                  });
                }}
              />
            </Box>
          </Box>
          <Box sx={{ marginLeft: isMediumScreen ? 0 : "8px" }}>
            <Typography>Cost Breakdown</Typography>
            <Box
              sx={{ marginTop: "8px", display: "flex", flexDirection: "row" }}
            >
              <TextFieldDebouncedNoInitialLoad
                sx={{ flex: 1, maxWidth: "150px" }}
                onFocus={(e) => e.target.select()}
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                size="small"
                label="Coil Cost (per Square Feet)"
                value={coil.coilCalculations?.costPerSquareFeetOfCoil}
                onChange={(e) => {
                  let coilCalculationsCopy = {
                    ...coil.coilCalculations,
                    costPerSquareFeetOfCoil: parseFloat(e.target.value),
                  };

                  onUpdateCoil({
                    ...coil,
                    coilCalculations: coilCalculationsCopy,
                  });
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
              <TextFieldDebouncedNoInitialLoad
                sx={{ flex: 1, maxWidth: "150px", marginLeft: "8px" }}
                onFocus={(e) => e.target.select()}
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                size="small"
                label="Square Feet of Coil"
                value={coil.coilCalculations?.squareFeetOfCoil}
                disabled
                // onChange={(e) => {
                //   let coilCalculationsCopy = {
                //     ...coil.coilCalculations,
                //     squareFeetOfCoil: parseFloat(e.target.value),
                //   };

                //   onUpdateCoil({
                //     ...coil,
                //     coilCalculations: coilCalculationsCopy,
                //   });
                // }}
              />
              <TextField
                sx={{ flex: 1, maxWidth: "150px", marginLeft: "8px" }}
                disabled
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="Total Coil Sheet Cost"
                symbol="$"
                position="start"
                value={coil.coilCalculations.materialCost}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box>
          <Typography>Pricing</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMediumScreen ? "column" : "row",
              marginTop: "8px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <TextFieldDebouncedNoInitialLoad
                sx={{ flex: 1, maxWidth: "150px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="GP %"
                value={
                  coil.variables?.gross_profit_margin
                    ? toTwoDecimals(coil.variables?.gross_profit_margin * 100.0)
                    : 0
                }
                onChange={(e) => {
                  let variables = {
                    ...coil.variables,
                    gross_profit_margin: Number(e.target.value ?? 0) / 100.0,
                  };
                  onUpdateCoil({
                    ...coil,
                    variables,
                  });
                }}
                //   onChange={(e) => {
                //     e.target.value = parseFloat(
                //       parseFloat(e.target.value).toFixed(4) / 100.0
                //     ).toFixed(4);
                //     handleChange("gross_profit_margin")(e);
                //   }}
                //   isOveridden={overrides?.gross_profit_margin}
                //   handleReset={resetOverride("gross_profit_margin")}

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ marginLeft: "4px" }}>
                      %
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                sx={{
                  flex: 1,
                  maxWidth: "150px",
                  marginLeft: "8px",
                }}
                size="small"
                disabled
                type="number"
                onFocus={(e) => e.target.select()}
                label="Gross Profit"
                value={coil.coilCalculations.grossProfitDollars}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginTop: isMediumScreen ? "8px" : 0,
                marginLeft: isMediumScreen ? 0 : "8px",
              }}
            >
              <AdornedInputDebouncedNoInitialLoad
                sx={{ width: "150px" }}
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Final Sale Price"
                value={toTwoDecimals(
                  coil.totalSellPrice ? coil.totalSellPrice : 0
                )}
                isOveridden={
                  coil.overrides &&
                  coil.overrides.total_sell_price !== null &&
                  coil.overrides.total_sell_price !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...coil.overrides,
                    total_sell_price: null,
                  };
                  onUpdateCoil({
                    ...coil,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
              <TextField
                sx={{ flex: 1, maxWidth: "150px", marginLeft: "8px" }}
                size="small"
                disabled
                type="number"
                onFocus={(e) => e.target.select()}
                label="Coil Price (per Square Foot)"
                // value={coil.coilCalculations.pricePerSquareFeetOfCoil}
                value={coil.pricePerSquareFeetOfCoil}
                InputProps={{
                  readOnly: true,
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                sx={{ flex: 1, maxWidth: "150px", marginLeft: "8px" }}
                size="small"
                disabled
                type="number"
                onFocus={(e) => e.target.select()}
                label="Coil Price (per Lineal Foot)"
                // value={coil.coilCalculations.pricePerLinealFootOfCoil}
                value={coil.pricePerLinealFootOfCoil}
                InputProps={{
                  readOnly: true,
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Coil;
